import React from "react";
import { Box, Paper } from "@mui/material";

const MainContentInformacion = ({ children, alturaResolucion }) => {
  return (
    <Paper
      sx={{
        height: alturaResolucion,
        borderRadius: "15px",
      }}
      className="paymentTransaccion_container"
      elevation={2}
    >
      <main
        style={{
          width: "100%",
          minHeight: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {children}
      </main>
    </Paper>
  );
};

export default MainContentInformacion;
